<div class="flex flex-col place-self-stretch max-md:gap-5 md:gap-3">
  <span class="text-center font-semibold text-[1.75rem] leading-[2.125rem] md:text-start">
    {{ 'FOOTER.EMAIL_SIGNUP_FORM.SUBSCRIBE_TO_OUR_NEWSLETTER' | translate }}
  </span>
  <input
    class="max-md-placeholder:font-[300] w-full border-b border-[#1E1E1E] bg-transparent max-md:placeholder:text-[1.5rem] max-md:placeholder:!font-[300] max-md:placeholder:leading-[2.0625rem]"
    #inputRef
    [class.border-red-500]="emailSignupControl.invalid && (emailSignupControl.dirty || emailSignupControl.touched)"
    [formControl]="emailSignupControl"
    placeholder="example@here.com"
  />
  @if (emailSignupControl.invalid && (emailSignupControl.dirty || emailSignupControl.touched)) {
    <div class="pt-1 text-sm text-red-500">
      @if (emailSignupControl.hasError('required')) {
        <span>{{ 'FORM.ERRORS.REQUIRED' | translate }}</span>
      }
      @if (emailSignupControl.hasError('email')) {
        <span>{{ 'FORM.ERRORS.EMAIL' | translate }}</span>
      }
    </div>
  }
</div>
@if (!messageType()) {
  <button
    type="button"
    [disabled]="emailSignupControl.invalid"
    [color]="lightMode() ? 'blue' : 'green'"
    (click)="emailSignupForm()"
    shButton
    full
    big
  >
    <ng-container>{{ 'FOOTER.EMAIL_SIGNUP_FORM.SIGN_ME_UP' | translate }}</ng-container>
    <sheba-arrow-start-icon [style.color]="emailSignupControl.invalid ? null : '#FFFFFF'" />
  </button>
} @else {
  @if (messageType() == 'success') {
    <div class="text-green-500" #messageRef tabindex="0">{{ footerData().successMessage }}</div>
  } @else {
    <div class="text-red-500" #messageRef tabindex="0">{{ footerData().errorMessage }}</div>
  }
}
